import { useAppSelector } from "@/redux/store/hooks";

const useUser = () => {
  const { registeredUser, unverifiedUser, type } = useAppSelector(
    (state) => state.user
  );

  const isUnverfiedUserLoggedIn = !!unverifiedUser?.token;
  const isRegisteredUserLoggedIn = !!registeredUser?.isLoggedIn;
  const isGuestUser =
    isRegisteredUserLoggedIn && !!registeredUser?.profile?.guest;
  const isFullyRegistered =
    isRegisteredUserLoggedIn && !registeredUser?.profile?.guest;
  const isUserAdmin = registeredUser.profile?.roleName?.indexOf("admin") > -1;
  const isPreviewUser = type === "PreviewUser";

  return {
    isUnverfiedUserLoggedIn,
    isRegisteredUserLoggedIn,
    isGuestUser,
    isFullyRegistered,
    isUserAdmin,
    isPreviewUser
  };
};

export default useUser;
